import { cn } from '../../@/lib/utils';
import { initialTab } from './config/initialtab';
import { EditConfirmationButtonsProps } from 'processhub-components-lib/dist/lib/types/dashboard';

export const EditConfirmationButtons: React.FC<EditConfirmationButtonsProps> = ({
  tabError,
  tabMode,
  setScreen,
  setNewTab,
  setTabError,
  submit,
}) => {
  const handleCancel = () => {
    if (tabMode === "new") {
      setScreen("");
      setNewTab(initialTab);
      setTabError("");
    } else {
      setScreen("");
    }
  };

  return (
    <div className={cn("2xl:mt-5", "flex gap-3 mr-6")}>
      <div className="text-red pl-2">{tabError}</div>
      <div className="flex-1" />
      <div className="flex items-center gap-3 h-min">
        <div className="btn-sec" onClick={handleCancel}>
          Cancel
        </div>
        <button className="btn" onClick={submit}>
          {tabMode === "new" ? "Add" : "Update"}
        </button>
      </div>
    </div>
  );
};